jQuery(document).ready(function($) {

    isSmallMobile = {
        any: function() {
            return $(window).width() < 767;
        }
    };
    
    $('[rel=popover]').popover({
        html: true,
        placement: 'bottom',
        content: function() {
            return $('.savingsDetailsList').html();
            //return $($(this).data('contentwrapper')).html();
        }
    });

    // *************************************************************************************************
    //	Homepage
    // *************************************************************************************************

    // Place Homepage only Javascript inside of IF statement
    // if (document.body.classList.contains('home')) {

    // }

});